/* eslint-disable */

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { RxCross2 } from "react-icons/rx";
import Swal from "sweetalert2";
// import SelectSearch from 'react-select-search'
import SelectSearch, { components, InputActionMeta } from "react-select";
import { Typeahead } from "react-bootstrap-typeahead";

import { FaArrowLeft } from "react-icons/fa";
import { useSelector } from "react-redux";
import BASE_API_URL from "../../../../api/api";
import apiInstance from "../../../../Utils/api";
const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 30px;
`;

const Center = styled.div`
  flex: 1;
  display: inline;
  text-align: center;
`;

const Button = styled.button`
  background: rgb(0, 7, 51);
  color: white;
  justify-content: center;
  padding: 5px 30px;
  border: none;
  border-radius: 10px;
  margin-top: 20px;
`;

const Title = styled.h5`
  font-weight: bold;
  margin-top: 10px;
`;
const Div = styled.div``;
const Label = styled.label``;
const Input = styled.input`
  width: 100%;
`;
const Span = styled.span`
  color: red;
`;
const Textarea = styled.textarea``;

const Select = styled.select`
  padding: 5px 7px;
  border-radius: 5px;
`;
const Option = styled.option``;

const Table = styled.table``;
const Thead = styled.thead``;
const Tbody = styled.tbody``;
const Tr = styled.tr`
  text-align: center;
`;
const Th = styled.th`
  font-size: 15px;
`;
const Td = styled.td`
  font-size: 14px;
`;

const Create = () => {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance;

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const [inputText, setInputText] = useState("");

  // const handleInputChange = (inputText: string, meta: InputActionMeta) => {
  //   if (meta.action !== "input-blur" && meta.action !== "menu-close") {
  //     setInputText(inputText);
  //   }
  // };

  const [code, setCode] = useState("");
  const [date, setDate] = useState("");
  const [doctors, setDoctors] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [therapists, setTherapists] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [machines, setMachines] = useState([]);
  const [accessories, setAccessories] = useState([]);
  const [medicineList, setMedicineList] = useState([]);
  const [items, setItems] = useState([]);
  const [isItem, setIsItem] = useState(false);
  const [id, setId] = useState("");
  const [accitems, setAccItems] = useState([]);
  const [isAccItem, setIsAccItem] = useState(false);

  const [accid, setAccId] = useState("");
  const [macitems, setMacItems] = useState([]);
  const [isMacItem, setIsMacItem] = useState(false);
  const [medItems, setMedItems] = useState([]);
  const [isMedItem, setIsMedItem] = useState(false);
  const [qty, setQty] = useState("");

  const [percent, setPercent] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [generalList, setGeneralList] = useState([]);
  const [isGenItem, setIsGenItem] = useState(false);
  const [generalSelection, setGeneralSelection] = useState([]);
  //Gen
  const [tableGenData, setTableGenData] = useState([]);
  const [selectGenOption, setSelectGenOption] = useState({
    id: "",
    name: "",
  });
  const customFilter = (option, searchText) => {
    if (
      option.data.first_name.toLowerCase().includes(searchText.toLowerCase()) ||
      option.data.last_name.toLowerCase().includes(searchText.toLowerCase()) ||
      option.data.gender.toLowerCase().includes(searchText.toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  };
  const [sellPrice, setSellPrice] = useState("");

  const [description, setDescription] = useState("");
  const [doctorname, setDoctorName] = useState("");
  const [therapistname, setTherapistName] = useState("");
  const [treatmenttime, setTreatmentTime] = useState("");
  const [treatmentCode, setTreatmentCode] = useState("");
  const [name, setName] = useState("");

  const [medSelection, setMedSelection] = useState([]);
  const [proMedSelection, setProMedSelection] = useState([]);
  const [accSelection, setAccSelection] = useState([]);

  const [machineSelection, setMachineSelection] = useState([]);

  // console.log(selection, 'sel')

  //Pro Medicine
  const [tableProData, setTableProData] = useState([]);
  const [selectOption, setSelectOption] = useState({
    id: "",
    name: "",
  });

  //Medicine
  const [tableMedData, setTableMedData] = useState([]);
  const [selectMedOption, setSelectMedOption] = useState({
    id: "",
    name: "",
  });

  //Pro Acc
  const [tableProAccData, setTableProAccData] = useState([]);
  const [selectProAccOption, setSelectProAccOption] = useState({
    id: "",
    name: "",
  });

  // const name = useLocation().pathname.split('/')[3]

  useEffect(() => {
    const getDoctors = async () => {
      const res = await api.get("doctors");
      setDoctors(res.data.data);
    };
    const getTherapists = async () => {
      const res = await api.get("therapists");
      setTherapists(res.data.data);
    };
    const getMedicine = async () => {
      const res = await api.get("medicine-items");
      setMedicineList(res.data.list);
    };

    const getProcedures = async () => {
      const res = await api.get("procedure-items");
      setProcedures(res.data.list);
    };
    const getAccessories = async () => {
      const res = await api.get("accessory-items");
      console.log(res.data.list);
      setAccessories(res.data.list);
    };
    const getGeneral = async () => {
      const res = await api.get("general-items");
      console.log(res.data.list);
      setGeneralList(res.data.list);
    };

    const getMachines = async () => {
      const res = await api.get("fixed-assets");
      setMachines(
        res.data.list.filter(
          (el) =>
            el.type == "Medical Equipment" ||
            el.type == "Surgery Equipment" ||
            el.type == "Medical Machinery",
        ),
      );
    };

    const getBranches = async () => {
      const res = await api.get("branches");
      setBranchList(res.data.list);
      console.log(
        res.data.list.map((i) => i._id),
        "b id",
      );
    };

    getBranches();

    getGeneral();
    getMedicine();
    getDoctors();
    getTherapists();
    getProcedures();
    getAccessories();
    getMachines();
  }, []);

  const handleSelect = (val) => {
    this.setState({ selected: val });
  };
  const filteredOptions = medicineList.filter((option) =>
    option.medicineItemName.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const handleSearchChange = (event) => {
    console.log(event, "ite");
    if (event !== null) {
      const SearchMedItem = medicineList.filter((option) =>
        option.medicineItemName.toLowerCase().includes(event.toLowerCase()),
      );
      console.log(
        medicineList.filter((option) =>
          option.medicineItemName.toLowerCase().includes(event.toLowerCase()),
        ),
        "res",
      );
      setMedicineList(SearchMedItem);
    } else {
      setMedicineList(medicineList);
    }
  };

  const handleSearchItem = (val) => {
    console.log("search");
  };

  //Start procedure medicine add row

  //NOTE Input Changes when input qty and per usage qty
  const handleProInputChange = (event, id, field) => {
    const newData = tableProData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableProData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleProAddRow = (id, name) => {
    // console.log(name, 'Pro name')
    setTableProData([
      ...tableProData,
      {
        id: tableProData.length + 1,
        name: name,
        item_id: id,
        qty: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleProGet = (event) => {
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const proName = selectedOption.getAttribute("data-name");
    setSelectOption({
      id: id,
      name: proName,
    });

    // const value = event.target.value
    // // Use the id, name, and value as needed
    // console.log('ID:', id)
    // console.log('Name:', proName)
    // console.log('Value:', value)
  };

  //NOTE to delete proecedure medicine
  const removeProcedure = (id) => {
    setTableProData(tableProData.filter((el) => el.id !== id));
  };
  //General
  const handleGeneralInputChange = (event, id, field) => {
    const newData = tableGenData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableGenData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleGeneralAddRow = (id, name) => {
    // console.log(name, 'Pro name')

    setTableGenData([
      ...tableGenData,
      {
        id: tableGenData.length + 1,
        name: name,
        item_id: id,
        qty: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsGenItem(true);
  };

  //NOTE to get Id and Name of procedure medicine

  //NOTE to delete proecedure medicine
  const removeGeneral = (id) => {
    // console.log(id, 'gen')

    tableGenData.filter((el, i) => el.id !== id);
  };
  //End procedure medicine add row

  //Start procedure medicine add row

  //NOTE Input Changes when input qty and per usage qty
  const handleMachineInputChange = (event, id, field) => {
    const newData = tableMachineData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    // console.log(newData)
    setTableMachineData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleMachineAddRow = (id, name) => {
    console.log(name, "Mac name");
    setTableMachineData([
      ...tableMachineData,
      {
        id: tableMachineData.length + 1,
        name: name,
        item_id: id,
        qty: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsMacItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleMacGet = (event) => {
    console.log(event, "Mac ID");
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const macName = selectedOption.getAttribute("data-name");
    setSelectMacOption({
      id: id,
      name: macName,
    });

    // const value = event.target.value
    // // Use the id, name, and value as needed
    // console.log('ID:', id)
    // console.log('Name:', proName)
    // console.log('Value:', value)
  };

  //NOTE to delete proecedure medicine
  const removeMac = (id) => {
    // console.log(id, 'Re Id')
    setTableMachineData(tableMachineData.filter((el) => el.id != id));
  };
  //End procedure medicine add row

  //Start Medicine add row
  //NOTE Input Changes when input qty and per usage qty
  const handleMedInputChange = (event, id, field) => {
    const newData = tableMedData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableMedData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleMedAddRow = (id, name) => {
    // console.log(name, 'Med name')
    setTableMedData([
      ...tableMedData,
      {
        id: tableMedData.length + 1,
        name: name,
        item_id: id,
        qty: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsMedItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleMedGet = (event) => {
    console.log(event, "ev");
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const medName = selectedOption.getAttribute("data-name");
    setSelectMedOption({
      id: id,
      name: medName,
    });

    // Use the id, name, and value as needed
    // console.log('ID:', id)
    // console.log('Name:', medName)
    // console.log('Value:', value)
  };

  //NOTE to delete proecedure medicine
  const removeMedicine = (id) => {
    setTableMedData(tableMedData.filter((el) => el.id != id));
  };

  //End Medicine add row

  //Start ProAccessory add row
  //NOTE Input Changes when input qty and per usage qty
  const handleProAccInputChange = (event, id, field) => {
    const newData = tableProAccData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableProAccData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleProAccAddRow = (id, name) => {
    console.log(id, "proAcc id");
    setTableProAccData([
      ...tableProAccData,
      {
        id: tableProAccData.length + 1,
        name: name,
        item_id: id,
        qty: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsAccItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleProAccGet = (event) => {
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const proAccName = selectedOption.getAttribute("data-name");
    setSelectProAccOption({
      id: id,
      name: proAccName,
    });

    const value = event.target.value;
    // Use the id, name, and value as needed
    console.log("ID:", id);
    console.log("Name:", proAccName);
    console.log("Value:", value);
  };

  //NOTE to delete proecedure medicine
  const removeProAcc = (id) => {
    setTableProAccData(tableProAccData.filter((el) => el.id !== id));
  };

  const handlePercent = (event) => {
    setPercent(event);
    const res = (event / 100) * totalPrice;
    const final = totalPrice - res;

    setSellPrice(final);
    // console.log((event / 100) * totalPrice, 'per res')
  };
  //End Medicine add row

  //End add table row and delete
  const create = () => {
    const data = {
      code: code,
      date: date,
      medicineItems: tableMedData,
      procedureItems: tableProData,
      accessoryItems: tableProAccData,
      generalItems: tableGenData,
      reason: description,
    };

    // alert(JSON.stringify(data))

    api
      .post("dismiss/items", data)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "Successfully Created",
          icon: "success",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
  };
  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/issue-list">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="text-lg ml-2">Back</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="card-body row border border-dark">
                <h4 className="text-bold">Issue To HO Create</h4>
                <div className="offset-2 col-8 py-5">
                  <div className="row">
                    <div className="col-4 form-group ">
                      <Label>Code</Label>
                      <Input
                        type="text"
                        className="form-control"
                        onChange={(e) => setCode(e.target.value)}
                      />
                    </div>
                    <div className="col-4 form-group">
                      <Label>Date</Label>
                      <Input
                        type="date"
                        className="form-control"
                        onChange={(e) => setDate(e.target.value)}
                      />
                    </div>

                    {/* <div className='col-4 form-group mt-3'>
                      <Label>
                        Doctor Name<Span>*</Span>
                      </Label>
                      <Select
                        className='form-control'
                        onChange={e => setDoctorName(e.target.value)}
                      >
                        <Option>Select Doctor</Option>
                        {doctors.map((doctor, i) => (
                          <Option value={doctor._id}>{doctor.name}</Option>
                        ))}
                      </Select>
                    </div> */}
                    {/* <div className='col-4 form-group mt-3'>
                      <Label>
                        Therapist Name<Span>*</Span>
                      </Label>
                      <Select
                        className='form-control'
                        onChange={e => setTherapistName(e.target.value)}
                      >
                        <Option>Select Therapist</Option>
                        {therapists.map((therapist, i) => (
                          <Option value={therapist._id}>
                            {therapist.name}
                          </Option>
                        ))}
                      </Select>
                    </div> */}
                    <div className="col-6 form-group mt-3">
                      <Label>Medicine</Label>

                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="medicineItemName"
                        onChange={setMedSelection}
                        options={medicineList}
                        placeholder="Choose a medicine items..."
                        selected={medSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleMedAddRow(
                            medSelection[0]._id,
                            medSelection[0].medicineItemName,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                          </Tr>
                        </Thead>
                        {isMedItem && (
                          <Tbody>
                            {tableMedData.map((item, index) => (
                              <Tr>
                                <Td>{++index}</Td>
                                <Td>{item.name}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.qty}
                                    onChange={(event) =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        "qty",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}

                                <Td>
                                  <RxCross2
                                    onClick={() => removeMedicine(item.id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>

                    {/* NOTE Procedure Medicine */}
                    <div className="col-6 form-group mt-3">
                      <Label>Procedure Medicine</Label>
                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="procedureItemName"
                        onChange={setProMedSelection}
                        options={procedures}
                        placeholder="Choose a procedure items..."
                        selected={proMedSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleProAddRow(
                            proMedSelection[0]._id,
                            proMedSelection[0].procedureItemName,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-4">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                          </Tr>
                        </Thead>
                        {isItem && (
                          <Tbody>
                            {tableProData.map((item, index) => (
                              <Tr>
                                <Td>{++index}</Td>
                                <Td>{item.name}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.qty}
                                    onChange={(event) =>
                                      handleProInputChange(
                                        event,
                                        item.id,
                                        "qty",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}

                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <RxCross2
                                    onClick={(e) => removeProcedure(item.id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>
                    {/* NOTE End Procedure Medicine */}

                    <div className="col-6 form-group mt-3">
                      <Label>Procedure Accessory</Label>
                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="accessoryItemName"
                        onChange={setAccSelection}
                        options={accessories}
                        placeholder="Choose a state accessory items..."
                        selected={accSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleProAccAddRow(
                            accSelection[0]._id,
                            accSelection[0].accessoryItemName,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                            {/* <Th>Purchase Price</Th> */}
                          </Tr>
                        </Thead>
                        {isAccItem && (
                          <Tbody>
                            {tableProAccData.map((item, index) => (
                              <Tr>
                                <Td>{++index}</Td>
                                <Td>{item.name}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.qty}
                                    onChange={(event) =>
                                      handleProAccInputChange(
                                        event,
                                        item.id,
                                        "qty",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}

                                <Td>
                                  <RxCross2
                                    onClick={() => removeProAcc(item.id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>

                    {/* NOTE End Procedure Medicine */}

                    <div className="col-6 form-group mt-3">
                      <Label>General Items</Label>
                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="generalItemName"
                        onChange={setGeneralSelection}
                        options={generalList}
                        placeholder="Choose a state accessory items..."
                        selected={generalSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleGeneralAddRow(
                            generalSelection[0]._id,
                            generalSelection[0].generalItemName,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                          </Tr>
                        </Thead>
                        {isGenItem && (
                          <Tbody>
                            {tableGenData.map((item, index) => (
                              <Tr>
                                <Td>{++index}</Td>
                                <Td>{item.name}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.qty}
                                    onChange={(event) =>
                                      handleGeneralInputChange(
                                        event,
                                        item.id,
                                        "qty",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}

                                <Td>
                                  <RxCross2
                                    onClick={() => removeGeneral(item.id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>

                    {/* NOTE End Procedure Accessory */}

                    <div className="col-6 form-group mt-3">
                      <Label>Description</Label>
                      <Textarea
                        className="form-control"
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <Top>
                  <Center>
                    <Button onClick={create}>Save</Button>
                  </Center>
                </Top>
              </div>
            </div>
          </section>
        </div>

    </>
  );
};

export default Create;
